// extracted by mini-css-extract-plugin
export default {"cls1":"Lightbox-CloseButton-module--cls1--dgX6v","cls2":"Lightbox-CloseButton-module--cls2--UnRRB Lightbox-CloseButton-module--cls1--dgX6v"};